import Chatbot from "./Chatbot";
import "./chatbot.css";
import { useState, useRef, useCallback, useEffect } from "react";
import "./App.css";

const BASE = "/api";

const DASHBOARD_FORMAT = [
  { section:"A", type:"data",  plant:"Lead Residue", label:"Lead bearing residue",            loc:"Pyro RM storage",      uom:"MT", code:"20002002" },
  { section:"A", type:"data",  plant:"PF Cake",      label:"PF cake RGTPL",                   loc:"Hydro RM storage",     uom:"MT", code:"20002000" },
  { section:"A", type:"data",  plant:"Cadmium",      label:"Cadmium Sponge SFG",              loc:"Cadmium RM storage",   uom:"MT", code:"SFG20000" },
  { section:"A", type:"data",  plant:"Cobalt",       label:"Cobalt Filter Cake",              loc:"Co plant shop floor",  uom:"MT", code:"SFG20001" },
  { section:"A", type:"data",  plant:"Copper",       label:"Cu Matte- Pyro",                  loc:"Cu Matte RM storage",  uom:"MT", code:"SFG20017" },
  { section:"B", type:"group", plant:"Lead Residue", label:"1. Lead Residue" },
  { section:"B", type:"data",  plant:"Lead Residue", label:"Pb Bullion- Cu dross",            loc:null, uom:"MT", code:"FG20005"  },
  { section:"B", type:"data",  plant:"Lead Residue", label:"Cu Matte- Pyro",                  loc:"Pyro shop floor", uom:"MT", code:"SFG20017" },
  { section:"B", type:"data",  plant:"Lead Residue", label:"Bag house dust - Cu Dross",       loc:"Pyro shop floor", uom:"MT", code:"SFG20018" },
  { section:"B", type:"group", plant:"PF Cake",      label:"2. PF Cake Plant" },
  { section:"B", type:"data",  plant:"PF Cake",      label:"Zinc Sulphate solution PF cake",  loc:null, uom:"MT", code:"FG20000"  },
  { section:"B", type:"data",  plant:"PF Cake",      label:"Copper cement SFG",               loc:null, uom:"MT", code:"SFG20002" },
  { section:"B", type:"data",  plant:"PF Cake",      label:"Cadmium Sponge SFG",              loc:null, uom:"MT", code:"SFG20000" },
  { section:"B", type:"data",  plant:"PF Cake",      label:"Cobalt Filter Cake",              loc:"Hydro shop floor", uom:"MT", code:"SFG20001" },
  { section:"B", type:"data",  plant:"PF Cake",      label:"CuSO4",                           loc:null, uom:"MT", code:"SFG20019" },
  { section:"B", type:"group", plant:"Cadmium",      label:"3. Cadmium Plant" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Cadmium Ingots",                  loc:null, uom:"MT", code:"FG20001"  },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Cd Cone",                         loc:null, uom:"MT", code:"SFG20016" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Zinc Residue - Cd plant grade 2", loc:null, uom:"MT", code:"SFG20004" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Crude Cadmium",                   loc:null, uom:"MT", code:"SFG20014" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Zinc Residue Cd plant",           loc:null, uom:"MT", code:"SFG20005" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Skimming Material",               loc:null, uom:"MT", code:"SFG20003" },
  { section:"B", type:"data",  plant:"Cadmium",      label:"Bag House dust- Cd plant",        loc:null, uom:"MT", code:"SFG20013" },
  { section:"B", type:"group", plant:"Cobalt",       label:"4. Cobalt Plant" },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Zinc Sulphate solution Co plant",  loc:null, uom:"MT", code:"FG20004"  },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Zinc Residue Co plant",            loc:null, uom:"MT", code:"SFG20006" },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Cobalt Filter cake grade 1",       loc:null, uom:"MT", code:"FG20003"  },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Zinc Residue - Cd plant grade 2",  loc:null, uom:"MT", code:"SFG20004" },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Acid leaching slag",               loc:null, uom:"MT", code:"SFG20007" },
  { section:"B", type:"data",  plant:"Cobalt",       label:"Iron slag-  Co plant",             loc:null, uom:"MT", code:"SFG20008" },
  { section:"B", type:"group", plant:"Copper",       label:"5. Copper Plant" },
  { section:"B", type:"data",  plant:"Copper",       label:"CuSO4 crystals",                   loc:null, uom:"M3", code:"FG20002"  },
  { section:"B", type:"data",  plant:"Copper",       label:"Copper Sponge",                    loc:null, uom:"MT", code:"SFG20010" },
  { section:"B", type:"data",  plant:"Copper",       label:"Iron slag- Cu plant",              loc:null, uom:"MT", code:"SFG20012" },
  { section:"B", type:"data",  plant:"Copper",       label:"Lead Silver slag",                 loc:null, uom:"MT", code:"SFG20011" },
];

const PLANT_COLORS = {
  "Lead Residue": { accent:"#C2410C", light:"#FFF0E6", badge:"#EA580C" },
  "PF Cake":      { accent:"#16A34A", light:"#F0FDF4", badge:"#22C55E" },
  "Cadmium":      { accent:"#1D4ED8", light:"#EFF6FF", badge:"#3B82F6" },
  "Cobalt":       { accent:"#7C3AED", light:"#F5F3FF", badge:"#8B5CF6" },
  "Copper":       { accent:"#B45309", light:"#FFF7ED", badge:"#F59E0B" },
};

function fmt(v) {
  if (!v || v === 0) return <span className="zero">—</span>;
  return Number(v).toFixed(2);
}
function Badge({ plant }) {
  const c = PLANT_COLORS[plant] || { badge:"#6B7280", light:"#F3F4F6" };
  return <span className="badge" style={{ background:c.light, color:c.badge }}>{plant}</span>;
}

// ── Upload Tab ────────────────────────────────────────────────────────────────
function UploadTab({ onUploaded }) {
  const [sapState,   setSapState]   = useState({ status:"idle", rows:0, name:"" });
  const [stockState, setStockState] = useState({ status:"idle", rows:0, name:"" });
  const [history,    setHistory]    = useState([]);
  const [resetting,  setResetting]  = useState(false);
  const [resetMsg,   setResetMsg]   = useState("");
  const sapRef   = useRef(null);
  const stockRef = useRef(null);

  const uploadFile = async (file, endpoint, setState) => {
    setState({ status:"loading", rows:0, name:file.name });
    const fd = new FormData();
    fd.append("file", file);
    try {
      const r = await fetch(`${BASE}/upload/${endpoint}`, { method:"POST", body:fd });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || "Upload failed");
      setState({ status:"done", rows:d.rows, name:file.name });
      onUploaded();
    } catch(e) {
      setState({ status:"error", rows:0, name:file.name, error:e.message });
    }
  };

  const handleReset = async () => {
    if (!window.confirm("This will DELETE all uploaded SAP data and closing stock. Are you sure?")) return;
    setResetting(true); setResetMsg("");
    try {
      const r = await fetch(`${BASE}/data/reset?confirm=YES_DELETE_ALL`, { method:"DELETE" });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail);
      setResetMsg("✓ All data cleared successfully.");
      setSapState({ status:"idle", rows:0, name:"" });
      setStockState({ status:"idle", rows:0, name:"" });
      setHistory([]);
    } catch(e) { setResetMsg("✗ " + e.message); }
    finally { setResetting(false); }
  };

  return (
    <div className="tab-content">
      <div className="page-header" style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",flexWrap:"wrap",gap:10}}>
        <div>
          <h1>Upload SAP Data</h1>
          <p>Upload SAP SAPUI5 Export daily. Mail sends automatically at your configured time.</p>
        </div>
        <button className="btn-danger" onClick={handleReset} disabled={resetting}>
          {resetting ? "Deleting…" : "🗑 Reset All Data"}
        </button>
      </div>

      {resetMsg && (
        <div className={resetMsg.startsWith("✓") ? "success-bar" : "error-bar"} style={{marginBottom:16}}>
          {resetMsg}
        </div>
      )}

      <div className="upload-grid">
        <div className={`upload-card ${sapState.status==="done"?"done":""} ${sapState.status==="error"?"error":""}`}
          onClick={() => sapRef.current.click()}
          onDragOver={e => e.preventDefault()}
          onDrop={e => { e.preventDefault(); const f=e.dataTransfer.files[0]; if(f) uploadFile(f,"sap",setSapState); }}>
          <div className="upload-icon">{sapState.status==="loading"?"⏳":sapState.status==="done"?"✅":"📊"}</div>
          <div className="upload-title">SAP Material Movements</div>
          <div className="upload-sub">SAPUI5 Export — upload this daily</div>
          <div style={{marginTop:14}}>
            {sapState.status==="done"    && <span className="chip green">✓ {sapState.rows} rows — {sapState.name}</span>}
            {sapState.status==="error"   && <span className="chip red">✗ {sapState.error}</span>}
            {sapState.status==="idle"    && <span className="chip gray">Click or drag to upload</span>}
            {sapState.status==="loading" && <span className="chip gray">Uploading…</span>}
          </div>
          <input ref={sapRef} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}}
            onChange={e => { const f=e.target.files[0]; if(f) uploadFile(f,"sap",setSapState); }} />
        </div>

        <div className={`upload-card ${stockState.status==="done"?"done":""} ${stockState.status==="error"?"error":""}`}
          onClick={() => stockRef.current.click()}
          onDragOver={e => e.preventDefault()}
          onDrop={e => { e.preventDefault(); const f=e.dataTransfer.files[0]; if(f) uploadFile(f,"stock",setStockState); }}>
          <div className="upload-icon">{stockState.status==="loading"?"⏳":stockState.status==="done"?"✅":"📦"}</div>
          <div className="upload-title">Closing Stock Data</div>
          <div className="upload-sub">Previous month stock — upload once per month</div>
          <div style={{marginTop:14}}>
            {stockState.status==="done"    && <span className="chip green">✓ {stockState.rows} rows — {stockState.name}</span>}
            {stockState.status==="error"   && <span className="chip red">✗ {stockState.error}</span>}
            {stockState.status==="idle"    && <span className="chip gray">Click or drag to upload</span>}
            {stockState.status==="loading" && <span className="chip gray">Uploading…</span>}
          </div>
          <input ref={stockRef} type="file" accept=".xlsx,.xls,.csv" style={{display:"none"}}
            onChange={e => { const f=e.target.files[0]; if(f) uploadFile(f,"stock",setStockState); }} />
        </div>
      </div>

      <div className="format-note">
        <strong>Expected columns — SAP SAPUI5 Export:</strong> Material Document · Material Document Year · Material · Plant · Storage Location · Posting Date · Goods Movement Type · Stock Type · Quantity
      </div>

      <div style={{marginTop:24}}>
        <button className="btn-outline"
          onClick={async()=>{const r=await fetch(`${BASE}/uploads/history`);setHistory(await r.json());}}>
          Show upload history
        </button>
        {history.length>0 && (
          <table className="data-table" style={{marginTop:12}}>
            <thead><tr><th>File</th><th>Type</th><th>Rows</th><th>Uploaded at</th></tr></thead>
            <tbody>{history.map(h=>(
              <tr key={h.id}><td>{h.filename}</td><td>{h.file_type}</td><td>{h.row_count}</td><td>{h.uploaded_at?.slice(0,16)}</td></tr>
            ))}</tbody>
          </table>
        )}
      </div>
    </div>
  );
}

// ── Dashboard Tab ─────────────────────────────────────────────────────────────
function DashboardTab() {
  const [dbRows,      setDbRows]    = useState([]);
  const [kpi,         setKpi]       = useState({});
  const [loading,     setLoading]   = useState(false);
  const [filterSec,   setFilterSec] = useState("All");
  const [availDates,  setAvailDates]= useState([]);
  const [dateFrom,    setDateFrom]  = useState("");
  const [dateTo,      setDateTo]    = useState("");
  const [mode,        setMode]      = useState("daily"); // "daily" | "range"

  const load = useCallback(async (from, to) => {
    setLoading(true);
    try {
      let url = `${BASE}/dashboard`;
      const params = new URLSearchParams();
      if (from) params.append("date_from", from);
      if (to)   params.append("date_to",   to);
      if (params.toString()) url += "?" + params.toString();
      const r = await fetch(url);
      const d = await r.json();
      setDbRows(d.rows || []);
      setKpi(d.kpi || {});
      setAvailDates(d.available_dates || []);
      // Set defaults on first load
      if (!from && d.kpi?.ftd) {
        setDateFrom(d.kpi.ftd);
        setDateTo(d.kpi.ftd);
      }
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(null, null); }, [load]);

  const handleApply = () => {
    if (mode === "daily") {
      load(dateTo, dateTo);
    } else {
      load(dateFrom, dateTo);
    }
  };

  const handleModeChange = (m) => {
    setMode(m);
    if (m === "daily" && dateTo) {
      load(dateTo, dateTo);
    }
  };

  const downloadExcel = async () => {
    try {
      const params = new URLSearchParams();
      if (dateFrom) params.append("date_from", mode==="daily"?dateTo:dateFrom);
      if (dateTo)   params.append("date_to",   dateTo);
      const r = await fetch(`${BASE}/download/excel?${params}`);
      if (!r.ok) { alert("Download failed"); return; }
      const blob = await r.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `DPR_${dateTo||kpi.ftd||"report"}.xlsx`;
      a.click();
    } catch(e) { alert("Error: " + e.message); }
  };

  const isDaily  = mode === "daily";
  const getRow   = (code, plant) => dbRows.find(r => r.code===code && r.plant===plant) || {};
  const secA     = DASHBOARD_FORMAT.filter(r => r.section==="A");
  const secB     = DASHBOARD_FORMAT.filter(r => r.section==="B");

  const ftdLabel  = isDaily ? "Day Total"    : "Day (To Date)";
  const mtdLabel  = isDaily ? "—"            : "Range Total";
  const showMTD   = !isDaily;

  return (
    <div className="tab-content">
      {/* Header */}
      <div className="page-header" style={{display:"flex",alignItems:"flex-start",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
        <div>
          <h1>Production Dashboard</h1>
          <p>
            {isDaily
              ? <>Showing: <strong>{dateTo || kpi.ftd || "—"}</strong> &nbsp;·&nbsp; {kpi.totalMovements||0} movements</>
              : <>Showing: <strong>{dateFrom}</strong> to <strong>{dateTo}</strong> &nbsp;·&nbsp; {kpi.totalMovements||0} movements</>
            }
          </p>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="btn-outline" onClick={downloadExcel}>⬇ Download Excel</button>
          <button className="btn-primary" onClick={() => load(isDaily?dateTo:dateFrom, dateTo)} disabled={loading}>
            {loading?"Refreshing…":"↺ Refresh"}
          </button>
        </div>
      </div>

      {/* Date filter bar */}
      <div className="date-filter-bar">
        {/* Mode toggle */}
        <div className="mode-toggle">
          <button className={`mode-btn ${isDaily?"active":""}`} onClick={()=>handleModeChange("daily")}>
            📅 Daily
          </button>
          <button className={`mode-btn ${!isDaily?"active":""}`} onClick={()=>handleModeChange("range")}>
            📆 Date Range
          </button>
        </div>

        {isDaily ? (
          <>
            <label className="filter-label">Select Date:</label>
            <select className="date-select" value={dateTo}
              onChange={e=>{setDateTo(e.target.value);load(e.target.value,e.target.value);}}>
              {availDates.map(d=><option key={d} value={d}>{d}</option>)}
            </select>
          </>
        ) : (
          <>
            <label className="filter-label">From:</label>
            <input type="date" className="date-input" value={dateFrom}
              onChange={e=>setDateFrom(e.target.value)}
              min={availDates[0]||""} max={availDates[availDates.length-1]||""}/>
            <label className="filter-label">To:</label>
            <input type="date" className="date-input" value={dateTo}
              onChange={e=>setDateTo(e.target.value)}
              min={availDates[0]||""} max={availDates[availDates.length-1]||""}/>
            <button className="btn-primary" style={{padding:"6px 16px"}} onClick={handleApply} disabled={loading}>
              Apply
            </button>
          </>
        )}

        <div style={{marginLeft:"auto",display:"flex",gap:8,alignItems:"center"}}>
          <label className="filter-label">Section:</label>
          <select value={filterSec} onChange={e=>setFilterSec(e.target.value)}>
            <option value="All">All</option>
            <option value="A">Section A</option>
            <option value="B">Section B</option>
          </select>
        </div>
      </div>

      {/* KPIs */}
      <div className="kpi-grid">
        {[
          {label: isDaily?"Production (Day)":"Production (Range)",  val:`${kpi.prodFTD||0} MT`,  sub: showMTD?`Range total: ${kpi.prodMTD||0} MT`:"Single day view",  accent:"#3B82F6"},
          {label: isDaily?"Dispatched (Day)":"Dispatched (Range)",  val:`${kpi.dispFTD||0} MT`,  sub: showMTD?`Range total: ${kpi.dispMTD||0} MT`:"Single day view",  accent:"#22C55E"},
          {label:"Input Processed",                                  val:`${kpi.inputMTD||0} MT`, sub: isDaily?"This day":"Full range",                                accent:"#F59E0B"},
          {label:"Closing Stock Total",                              val:`${kpi.stockMT||0} MT`,  sub:"All materials",                                                  accent:"#8B5CF6"},
        ].map(k=>(
          <div key={k.label} className="kpi-card" style={{borderLeftColor:k.accent}}>
            <div className="kpi-val">{k.val}</div>
            <div className="kpi-label">{k.label}</div>
            <div className="kpi-sub">{k.sub}</div>
          </div>
        ))}
      </div>

      {/* Section A */}
      {(filterSec==="All"||filterSec==="A") && (
        <div className="table-section">
          <div className="section-head dark">A. Input — Smelter Residue</div>
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th className="left" rowSpan="2">Material</th>
                  <th className="left" rowSpan="2">Storage Location</th>
                  <th className="center" rowSpan="2">UOM</th>
                  <th className="center" colSpan={showMTD?2:1}>Material Processed</th>
                  <th className="center" colSpan={showMTD?2:1}>Received</th>
                  <th className="center" rowSpan="2">Opening Stock</th>
                  <th className="center" rowSpan="2">Closing Stock</th>
                </tr>
                <tr>
                  <th className="center">{ftdLabel}</th>
                  {showMTD && <th className="center">{mtdLabel}</th>}
                  <th className="center">{ftdLabel}</th>
                  {showMTD && <th className="center">{mtdLabel}</th>}
                </tr>
              </thead>
              <tbody>
                {secA.map((row,i)=>{
                  const d=getRow(row.code,row.plant);
                  return (<tr key={i}>
                    <td className="left"><Badge plant={row.plant}/><span style={{marginLeft:8}}>{row.label}</span></td>
                    <td className="left muted">{row.loc||"—"}</td>
                    <td className="center muted">{row.uom}</td>
                    <td className={`center ${d.prodFTD>0?"bold":""}`}>{fmt(d.prodFTD)}</td>
                    {showMTD && <td className="center">{fmt(d.prodMTD)}</td>}
                    <td className={`center ${d.rcptFTD>0?"green":""}`}>{fmt(d.rcptFTD)}</td>
                    {showMTD && <td className={`center ${d.rcptMTD>0?"green":""}`}>{fmt(d.rcptMTD)}</td>}
                    <td className="center amber">{fmt(d.openingStock)}</td>
                    <td className="center blue bold">{fmt(d.closingStock)}</td>
                  </tr>);
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Section B */}
      {(filterSec==="All"||filterSec==="B") && (
        <div className="table-section">
          <div className="section-head dark">B. Output (Recovery)</div>
          <div className="table-wrap">
            <table className="data-table">
              <thead>
                <tr>
                  <th className="left" rowSpan="2">Material</th>
                  <th className="center" rowSpan="2">UOM</th>
                  <th className="center" colSpan={showMTD?2:1}>Production</th>
                  <th className="center" colSpan={showMTD?2:1}>Dispatches</th>
                  <th className="center" rowSpan="2">Opening Stock</th>
                  <th className="center" rowSpan="2">Closing Stock</th>
                </tr>
                <tr>
                  <th className="center">{ftdLabel}</th>
                  {showMTD && <th className="center">{mtdLabel}</th>}
                  <th className="center">{ftdLabel}</th>
                  {showMTD && <th className="center">{mtdLabel}</th>}
                </tr>
              </thead>
              <tbody>
                {secB.map((row,i)=>{
                  if(row.type==="group"){
                    const c=PLANT_COLORS[row.plant]||{accent:"#374151",light:"#F8FAFC"};
                    const cols = showMTD ? 8 : 6;
                    return (<tr key={i}><td colSpan={cols} style={{background:c.light,padding:"8px 14px",fontWeight:600,fontSize:13,borderLeft:`3px solid ${c.accent}`,color:c.accent}}>{row.label}</td></tr>);
                  }
                  const d=getRow(row.code,row.plant);
                  const c=PLANT_COLORS[row.plant]||{};
                  return (<tr key={i}>
                    <td className="left" style={{paddingLeft:20}}>{row.label}</td>
                    <td className="center muted">{row.uom}</td>
                    <td className="center" style={{fontWeight:d.prodFTD>0?600:400,color:d.prodFTD>0?(c.accent||"inherit"):"inherit"}}>{fmt(d.prodFTD)}</td>
                    {showMTD && <td className="center">{fmt(d.prodMTD)}</td>}
                    <td className={`center ${d.dispFTD>0?"green bold":""}`}>{fmt(d.dispFTD)}</td>
                    {showMTD && <td className={`center ${d.dispMTD>0?"green":""}`}>{fmt(d.dispMTD)}</td>}
                    <td className="center amber">{fmt(d.openingStock)}</td>
                    <td className="center blue bold">{fmt(d.closingStock)}</td>
                  </tr>);
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Mail Settings Tab ─────────────────────────────────────────────────────────
function MailTab() {
  const [config,  setConfig]  = useState({to_email:"",cc_email:"",subject_template:"RGTPL Daily Production Report — {date}",body_template:"",send_time:"18:00",auto_send:true});
  const [saving,  setSaving]  = useState(false);
  const [saved,   setSaved]   = useState(false);
  const [testing, setTesting] = useState(false);
  const [testMsg, setTestMsg] = useState("");
  const [preview, setPreview] = useState({subject:"",body:""});
  const [showPrev,setShowPrev]= useState(false);
  const [history, setHistory] = useState([]);

  useEffect(()=>{ fetch(`${BASE}/mail/config`).then(r=>r.json()).then(d=>{if(d.to_email)setConfig(d);}).catch(()=>{}); },[]);

  const handleSave = async()=>{
    if(!config.to_email){alert("To email is required");return;}
    setSaving(true);setSaved(false);
    try{
      const r=await fetch(`${BASE}/mail/config`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(config)});
      const d=await r.json();if(!r.ok)throw new Error(d.detail);
      setSaved(true);setTimeout(()=>setSaved(false),4000);
    }catch(e){alert("Save failed: "+e.message);}finally{setSaving(false);}
  };

  const handleTest=async()=>{
    setTesting(true);setTestMsg("");
    try{
      const r=await fetch(`${BASE}/mail/test`,{method:"POST"});
      const d=await r.json();if(!r.ok)throw new Error(d.detail);
      setTestMsg("✓ Test mail sent to "+d.to);
    }catch(e){setTestMsg("✗ "+e.message);}finally{setTesting(false);}
  };



  return (
    <div className="tab-content">
      <div className="page-header"><h1>Mail Settings</h1><p>Configure once. Mail auto-sends daily at your set time with DPR Excel attached.</p></div>

      <div className="how-it-works">
        <div className="hiw-step"><div className="hiw-num">1</div><div className="hiw-text"><strong>Upload SAP file</strong><br/>Any time of day</div></div>
        <div className="hiw-arrow">→</div>
        <div className="hiw-step"><div className="hiw-num">2</div><div className="hiw-text"><strong>At your set time</strong><br/>e.g. 6:00 PM daily</div></div>
        <div className="hiw-arrow">→</div>
        <div className="hiw-step"><div className="hiw-num">3</div><div className="hiw-text"><strong>DPR Excel generated</strong><br/>All 32 materials with numbers</div></div>
        <div className="hiw-arrow">→</div>
        <div className="hiw-step"><div className="hiw-num">4</div><div className="hiw-text"><strong>Mail sent automatically</strong><br/>Excel attached</div></div>
      </div>

      <div className="mail-layout">
        <div className="mail-settings">
          <div className="card">
            <div className="card-title">📧 Configure Once</div>
            <label>To Email <span style={{color:"#EF4444"}}>*</span></label>
            <input value={config.to_email||""} onChange={e=>setConfig({...config,to_email:e.target.value})} placeholder="management@rgtpl.com"/>
            <label>CC Email <span style={{color:"#9CA3AF",fontSize:11}}>(optional, comma separated)</span></label>
            <input value={config.cc_email||""} onChange={e=>setConfig({...config,cc_email:e.target.value})} placeholder="gm@rgtpl.com, ops@rgtpl.com"/>
            <label>Send Time <span style={{color:"#9CA3AF",fontSize:11}}>(daily — server time)</span></label>
            <input
              style={{width:"100%",padding:"9px 12px",border:"1px solid #E5E7EB",borderRadius:8,fontSize:13,fontFamily:"inherit",marginBottom:4}}
              value={config.send_time||"18:00"}
              onChange={e=>setConfig({...config,send_time:e.target.value})}
              placeholder="HH:MM e.g. 18:30"
              pattern="[0-2][0-9]:[0-5][0-9]"
            />
            <div style={{fontSize:11,color:"#9CA3AF",marginBottom:12}}>Enter in 24-hour format — e.g. <code style={{background:"#F3F4F6",padding:"1px 4px",borderRadius:3}}>06:00</code> for 6 AM, <code style={{background:"#F3F4F6",padding:"1px 4px",borderRadius:3}}>18:30</code> for 6:30 PM</div>
            <label>Subject Line</label>
            <input value={config.subject_template||""} onChange={e=>setConfig({...config,subject_template:e.target.value})} placeholder="RGTPL Daily Production Report — {date}"/>
            <div style={{fontSize:11,color:"#9CA3AF",marginTop:-8,marginBottom:12}}>Use <code style={{background:"#F3F4F6",padding:"1px 4px",borderRadius:3}}>{"{date}"}</code> as placeholder</div>
            <label>Mail Body <span style={{color:"#9CA3AF",fontSize:11}}>(draft once — reused daily with updated numbers)</span></label>
            <textarea className="draft-textarea" style={{minHeight:160,marginBottom:6}}
              value={config.body_template||""} onChange={e=>setConfig({...config,body_template:e.target.value})}
              placeholder={"Leave blank for default body.\n\nAvailable placeholders:\n{date}              → report date\n{prod_ftd}          → production today (MT)\n{prod_mtd}          → production range (MT)\n{disp_ftd}          → dispatches today\n{disp_mtd}          → dispatches range\n{input_mtd}         → inputs processed\n{production_lines}  → bullet list\n{dispatch_lines}    → bullet list\n{input_lines}       → bullet list"}/>
            <div style={{display:"flex",gap:8,marginBottom:8}}>
              <button className="btn-primary" style={{flex:1}} onClick={handleSave} disabled={saving}>{saving?"Saving…":"💾 Save Settings"}</button>
              <button className="btn-outline" onClick={async()=>{const r=await fetch(`${BASE}/mail/preview`);const d=await r.json();setPreview(d);setShowPrev(true);}}>👁 Preview</button>
            </div>
            {saved && <div className="success-bar">✓ Saved! Mail will send daily at {config.send_time}.</div>}
          </div>
          <div className="card" style={{marginTop:16}}>
            <div className="card-title">🧪 Test Now</div>
            <p style={{fontSize:12,color:"#6B7280",marginBottom:12}}>Sends the report immediately to verify SMTP is working.</p>
            <button className="btn-outline full-width" onClick={handleTest} disabled={testing}>{testing?"Sending…":"📨 Send Test Mail Now"}</button>
            {testMsg && <div className={`${testMsg.startsWith("✓")?"success-bar":"error-bar"}`} style={{marginTop:10}}>{testMsg}</div>}
          </div>
        </div>

        <div style={{flex:1,display:"flex",flexDirection:"column",gap:16}}>
          {showPrev && (
            <div className="card">
              <div className="card-title" style={{display:"flex",justifyContent:"space-between"}}>
                <span>👁 Mail Preview</span>
                <button className="btn-outline" style={{fontSize:11,padding:"2px 8px"}} onClick={()=>setShowPrev(false)}>✕</button>
              </div>
              <div style={{fontSize:12,color:"#6B7280",marginBottom:6}}>Subject:</div>
              <div style={{background:"#F8FAFC",padding:"8px 12px",borderRadius:6,fontSize:13,marginBottom:12,fontWeight:500}}>{preview.subject||"—"}</div>
              <div style={{fontSize:12,color:"#6B7280",marginBottom:6}}>Body:</div>
              <pre style={{background:"#F8FAFC",padding:"12px",borderRadius:6,fontSize:12,fontFamily:"'DM Mono',monospace",whiteSpace:"pre-wrap",maxHeight:300,overflow:"auto",color:"#374151"}}>{preview.body||"No data yet"}</pre>
            </div>
          )}
          <div className="card" style={{flex:1}}>
            <div className="card-title" style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <span>📋 Send History</span>
              <button className="btn-outline" style={{fontSize:12,padding:"4px 10px"}} onClick={async()=>{const r=await fetch(`${BASE}/mail/history`);setHistory(await r.json());}}>Load</button>
            </div>
            {history.length===0 ? (
              <div style={{textAlign:"center",padding:"30px 0",color:"#9CA3AF"}}>
                <div style={{fontSize:28,marginBottom:8}}>📭</div>
                <div style={{fontSize:13}}>No mails sent yet — click Load to check</div>
              </div>
            ) : (
              <table className="data-table" style={{marginTop:8}}>
                <thead><tr><th className="left">Sent at</th><th className="left">To</th><th className="left">Subject</th><th className="center">Status</th></tr></thead>
                <tbody>{history.map(h=>(<tr key={h.id}>
                  <td className="left muted">{h.sent_at?.slice(0,16)}</td>
                  <td className="left">{h.to_email}</td>
                  <td className="left muted" style={{maxWidth:180,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{h.subject}</td>
                  <td className="center"><span className={`chip ${h.status==="sent"?"green":"red"}`}>{h.status}</span></td>
                </tr>))}</tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [tab,setTab]=useState("upload");
  const [dbLive,setDbLive]=useState(false);
  useEffect(()=>{fetch(`${BASE}/health`).then(r=>setDbLive(r.ok)).catch(()=>setDbLive(false));},[]);
  return (
    <div className="app">
      <header className="topbar">
        <div className="topbar-left"><span className="logo">RGTPL DPR</span><span className="logo-sub">Daily Production Report</span></div>
        <nav className="topbar-nav">
          {[["upload","⬆ Upload"],["dashboard","▦ Dashboard"],["mail","✉ Mail Settings"],["chat","💬 Analytics"]].map(([k,l])=>(
            <button key={k} className={`nav-btn ${tab===k?"active":""}`} onClick={()=>setTab(k)}>{l}</button>
          ))}
        </nav>
        <div className="topbar-right">
          <span className={`status-dot ${dbLive?"live":"offline"}`}></span>
          <span className="status-label">{dbLive?"API connected":"API offline"}</span>
        </div>
      </header>
      <main className="main" style={{overflow: tab==="chat" ? "hidden" : "auto", display: tab==="chat" ? "block" : undefined}}>
        {tab==="upload"    && <UploadTab onUploaded={()=>setDbLive(true)}/>}
        {tab==="dashboard" && <DashboardTab/>}
        {tab==="mail"      && <MailTab/>}
        {tab==="chat"      && <Chatbot/>}
      </main>
    </div>
  );
}
